import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import ClientDashboard from './pages/ClientDashboard';
import BookingSuccess from './pages/BookingSuccess';
import ProviderProfile from './pages/ProviderProfile';
import SharePage from './pages/SharePage';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import DealsPage from './pages/DealsPage';
import AdminPage from './AdminPage';
import ForgotPassword from './pages/ForgotPassword';

function ProtectedRoute({ children }) {
  const [authState, setAuthState] = useState('loading');

  useEffect(() => {
    getCurrentUser()
      .then(() => setAuthState('authenticated'))
      .catch(() => setAuthState('unauthenticated'));
  }, []);

  if (authState === 'loading') return (
    <div style={{ background: 'var(--cream)', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div style={{ width: 40, height: 40, borderRadius: '50%', border: '3px solid var(--green)', borderTopColor: 'transparent', animation: 'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
  if (authState === 'unauthenticated') return <Navigate to="/login" />;
  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/deals" element={<DealsPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/dashboard" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />
        <Route path="/client" element={<Navigate to="/client-dashboard" replace />} />
        <Route path="/client-dashboard" element={
          <ProtectedRoute><ClientDashboard /></ProtectedRoute>
        } />
        <Route path="/provider/:providerId" element={
          <ProtectedRoute><ProviderProfile /></ProtectedRoute>
        } />
        <Route path="/booking-success" element={
          <ProtectedRoute><BookingSuccess /></ProtectedRoute>
        } />
        <Route path="/share/:providerId" element={
          <ProtectedRoute><SharePage /></ProtectedRoute>
        } />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </Router>
  );
}

export default App;